import { FilterAccordion } from './filter-accordion';

export default FilterAccordion;
